/**
 * The body PUT /admin/users/:id needs: the route is a full replace, so every field goes back as
 * stored, with the change on top. Teams go only when the change names them (M1, 2026-09-22): a
 * role that reads the person without their teams sent [] and cleared them.
 */
import type { ApiUserFull, UserWrite } from '@/api/data';

export const fullBody = (cur: ApiUserFull, change: UserWrite): UserWrite => ({
  username: cur.username,
  name: cur.name ?? '',
  lastname: cur.lastname ?? '',
  phone: cur.phone ?? '',
  address: cur.address ?? '',
  email: cur.email ?? '',
  gender: cur.gender ?? '',
  hourly_rate: cur.hourly_rate,
  monthly_rate: cur.monthly_rate,
  contract_type: cur.contract_type,
  active_status: cur.active_status,
  // the agreed week is sent only when changed, as agreed_week_hours; max_hours_per_week is what the
  // API shows and is never written back (plan 0027 B)
  employee_id: cur.employee_id,
  // teams only when the change names them (the drawer sends team_ids only when they changed):
  // a role that reads the person without their teams sent [] here and cleared them (M1)
  ...change,
});
